import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './store/store'

import './assets/css/style.css'
import Theme from './components/theme'

import { loadScripts } from './utils/dynamicScriptLoader'

const renderComponents = () =>
    ReactDOM.render(
        <Provider store={store}>
            <Theme />
        </Provider>,
        document.getElementById('root')
    )

const renderErrorScreen = () =>
    ReactDOM.render(<div />, document.getElementById('root'))

const startApp = () => {
    window.initMap = function() {
    };
    var scripts = [
        {
            googleMaps:
                'https://maps.googleapis.com/maps/api/js?key=' +
                process.env.REACT_APP_GOOGLE_API_KEY + '&callback=initMap'
        },
    ]

    loadScripts(scripts)
        .then(() => {
            renderComponents()
        })
        .catch(() => {
            renderErrorScreen()
        })
}

startApp()

//
//
// ReactDOM.render(
//     <Provider store={store}>
//         <Theme/>
//     </Provider>,
//     document.getElementById('root')
// );
